import { render, staticRenderFns } from "./UserLinkLandingPageRedesign.vue?vue&type=template&id=6504b3ba"
import script from "./UserLinkLandingPageRedesign.vue?vue&type=script&lang=js"
export * from "./UserLinkLandingPageRedesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports